import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("g", { fill: "currentColor" }, [
      createElementVNode("path", { d: "M8.5 4.02h1.4s1 0 1 1V10s0 1-1 1H8.5s-1 0-1-1V5.02s0-1 1-1" }),
      createElementVNode("path", { d: "M17.54 0H6.46a3 3 0 0 0-3 3v18a3 3 0 0 0 3 3h11.08a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3m1 21a1 1 0 0 1-1 1H6.46a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h11.08a1 1 0 0 1 1 1Z" })
    ], -1)
  ]));
}
const computerDeviceMobilePhoneAndroidSamsungBack = { render };
export {
  computerDeviceMobilePhoneAndroidSamsungBack as default,
  render
};
//# sourceMappingURL=computer-device-mobile-phone-android-samsung-back.svg.js.map
